<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <pr-input-select-template
      formControlName="realEstateOwnershipType"
      [options]="options"
      [isGrid]="true"
    >
      <ng-template #optionTemplate let-option let-id="index">
        <div class="col-md-6 mt">
          <residence-box
            [suffix]="option.suffix"
            [title]="option.label"
            [svg]="option.svg"
          ></residence-box>
        </div>
      </ng-template>
    </pr-input-select-template>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
